const React = require('react');
import QueryActions from '../actions/QueryActions';
import ControlPropertyConst from '../formItem/ControlPropertyConst';
const {SortDirectionStore} = require('../stores/QueryStores');


const LookupSortableHeaderCell = React.createClass({
  	propTypes: {
	    column: React.PropTypes.shape({ name: React.PropTypes.node })
	},

	getInitialState(){
	    return {
            sortDirection: '',
            notNull:this.props.column.notNull,
            label:this.props.column.name
        };
    },
    
    componentDidMount:function componentDidMount() {

		this.unsubscribeUpdateSortDirection = SortDirectionStore.listen(this.onUpdateSortDirection);
    },

    onUpdateSortDirection:function(groupAlias,arg)
    {
        var _sortDirection;
        var _columnKey=this.props.column.key.toLowerCase();
        if(arg.hasOwnProperty(_columnKey)){
            _sortDirection=arg[_columnKey];
        }
        this.setState({sortDirection:_sortDirection})
        
    },

    onCmdUpdateControlLabel:function(name,_label)
    {
        if(this.props.column.xmlName == name)
        {
            this.setState({label:_label});
        }
    },

    onCmdUpdateControlProperty:function(name,property,value)
    {
        if(this.props.column.xmlName == name)
        {
            if(property == ControlPropertyConst.NOTNULL)
            {
                this.setState({notNull:value});
            }
        }
    },

 
    getSortByText: function() 
    {

        let unicodeKeys = {
            ASC: 9650,
            DESC: 9660
        };
        var _sortDirection=this.state.sortDirection;
        var ret;
        if(_sortDirection==undefined||_sortDirection==''){
            ret='';
        }else{
            ret=String.fromCharCode(unicodeKeys[_sortDirection]);
        }
        // var ret= _sortDirection==undefined?'':(String.fromCharCode(unicodeKeys[_sortDirection]));
            // console.log('ret:'+ret);
        return ret;

    },

    onClick:function(e) 
    {
        e.stopPropagation();
        e.preventDefault();
        var columnKey=this.props.column.key;
        var sortDirection=this.state.sortDirection;
        var _sortDirection;
        if(sortDirection=='ASC')
        {
        _sortDirection='DESC'
        }else if(sortDirection=='DESC'){
        _sortDirection='ASC'
        }else{
        _sortDirection='ASC'
        }
        QueryActions.autoFormLookupGridHeaderClickSort(columnKey,_sortDirection,this.props.lookupKey);
        //this.setState({sortDirection:_sortDirection})
    },

    getIconStyle:function()
    {

        var iconStyle={};
        iconStyle['fontSize']='8px';
        iconStyle['color']='red';
        var notNull=this.state.notNull;
        if(!notNull){
        iconStyle['display']='none';
        }
        return iconStyle;
    },


    render: function()
    {
        let xmlName = "";
        if(this.props.column)
            xmlName = this.props.column.key;
        return (
        <div data-xmlName={xmlName} alt="" style={{cursor: 'pointer',textAlign:this.props.textAlign}} onClick={this.onClick}>
            <i className='fa fa-snowflake-o' style={this.getIconStyle()}></i>
            {this.state.label}
            <span className="pull-right">{this.getSortByText()}</span>
            
        </div>
        );
    }
});

module.exports = LookupSortableHeaderCell;



// WEBPACK FOOTER //
// ./src/components/LookupHeaderCell.js